export const account = {
    title: "내 정보",
    name: "이름",
    email: "메일",
    schoolId: "학번",
    course: "과정",
    major: "전공",
    interestedDepartments: "관심 학과",
    logout: "로그아웃",
    sparcsssoCaption: "이 정보는 <bold>SPARCS SSO</bold>에서 변경할 수 있습니다",
    kaistPortalCaption:
        "이 정보는 KAIST Portal과 연동됩니다. 정보가 일치하지 않을 경우 <bold>otlplus@sparcs.org</bold>로 문의해주세요",
}
